var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeriousNotificationLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "30FB54A5-565F-400C-B32F-A3512FC36A7A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.09487651,10.3041788 C3.23007715,10.1689782 3.41344858,10.0930233 3.60465116,10.0930233 L12.255814,10.0930233 C12.6539727,10.0930233 12.9767442,9.7702518 12.9767442,9.37209302 L12.9767442,2.1627907 C12.9767442,1.76463192 12.6539727,1.44186047 12.255814,1.44186047 L2.1627907,1.44186047 C1.76463192,1.44186047 1.44186047,1.76463192 1.44186047,2.1627907 L1.44186047,11.9571949 L3.09487651,10.3041788 Z M3.90327024,11.5348837 L1.23070489,14.2074491 C0.776544175,14.6616098 1.11022302e-15,14.3399547 1.11022302e-15,13.6976744 L1.11022302e-15,2.1627907 C1.11022302e-15,0.968314378 0.968314378,1.11022302e-15 2.1627907,1.11022302e-15 L12.255814,1.11022302e-15 C13.4502903,1.11022302e-15 14.4186047,0.968314378 14.4186047,2.1627907 L14.4186047,9.37209302 C14.4186047,10.5665693 13.4502903,11.5348837 12.255814,11.5348837 L3.90327024,11.5348837 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24082109,5.67008751 C8.17667672,5.80674447 8.05274872,5.90150797 7.90935394,5.92354911 L5.7470155,6.25592105 L7.31132344,7.85820157 C7.41528111,7.96468275 7.46273174,8.11815658 7.43820022,8.26857056 L7.06911697,10.5315891 L9.00234023,9.46244997 C9.13076268,9.39142792 9.28419856,9.39142792 9.41262101,9.46244997 L11.3458443,10.5315891 L10.976761,8.26857056 C10.9522295,8.11815658 10.9996801,7.96468275 11.1036378,7.85820157 L12.6679457,6.25592105 L10.5056073,5.92354911 C10.3622125,5.90150797 10.2382845,5.80674447 10.1741402,5.67008751 L9.20748062,3.61065891 L8.24082109,5.67008751 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3_ShomreyHaderech_New",
    transform: "translate(-222.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(222.000000, 356.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#040B44",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "police",
    transform: "translate(6.488372, 6.488372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-square",
    transform: "translate(1.441860, 1.441860)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#F2F3F8",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-black",
    mask: "url(#mask-2)",
    fill: "#F2F3F8"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.441860, -1.441860)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 17.3023256,
    height: 17.3023256
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#F2F3F8",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeriousNotificationLetter);
export default __webpack_public_path__ + "static/media/SeriousNotificationLetter.02238f9d97594fbe80fbd2a4e24b9e8f.svg";
export { ForwardRef as ReactComponent };